import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import { CenterContainer, Box, Separator } from '../../components/containers';
import { Headline } from '../../components/text';
import { ButtonRounded } from '../../components/actions';
import { DEFAULT_CUSTOMER_PAGE } from '../../App';
import s from './index.css';

class NotFoundPage extends React.Component {
    render() {
        return (
            <CenterContainer>
                <Box addPadding={true}>
                    <Headline size="large">This page does not exist</Headline>

                    <Separator type="narrow" />

                    <div className={s.buttonContainer}>
                        <ButtonRounded
                            onClick={this.handleGoBack}
                            label="Go to home page"
                            align="center"
                            design="filled"
                        />
                    </div>
                </Box>
            </CenterContainer>
        );
    }

    handleGoBack = e => {
        this.props.dispatch(push(DEFAULT_CUSTOMER_PAGE));
    };
}

export default connect()(NotFoundPage);



// WEBPACK FOOTER //
// ./app/web/src/container/404Page/index.jsx